export const platformStatisticsWebapp = {
  id: 9,
  title: "Platform Statistics Webapp",
  activityId: 7,
  startDate: '2025-06-01',
  endDate: '2025-07-30',
  description: "Built a Streamlit webapp in 1 month, enabling automated insights into platform stats for KPI-based management decisions.",
  categorizedSkills: {
    profession: [
      { name: "Software Development", weight: 1 },
      { name: "Data Analytics", weight: 1 }
    ],
    tools: [
      { name: "Streamlit", weight: 1 }
    ],
    language: [
      { name: "Python", weight: 0.9 }
    ],
    lead: []
  },
  goal: "Enable automated insights into platform statistics for KPI-based management decisions",
  detailsFile: "platform-statistics-webapp.md", // Reference to markdown file
  metrics: [],
  role: "",
  teamSize: "1",
  git: "inner source",
  link: "inner source",
  isProfessional: true,
  isVisible: false // Hide this project from visualization
};
